import { render, staticRenderFns } from "./EducationChallenges.vue?vue&type=template&id=53d8f882&scoped=true&"
import script from "./EducationChallenges.vue?vue&type=script&lang=js&"
export * from "./EducationChallenges.vue?vue&type=script&lang=js&"
import style0 from "./EducationChallenges.vue?vue&type=style&index=0&id=53d8f882&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d8f882",
  null
  
)

export default component.exports